import React, { useState, useEffect } from 'react'

function ZPLRenderer({ zplCode }) {
  const [imageURL, setImageURL] = useState('')

  useEffect(() => {
    // URL do serviço ZPL to PNG Converter
    const converterURL = `https://api.labelary.com/v1/printers/8dpmm/labels/4x6/0/`
    const requestOptions = {
      method: 'POST',
      body: zplCode,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    }

    // Faça uma solicitação para o serviço para converter o ZPL em uma imagem
    fetch(converterURL, requestOptions)
      .then((response) => response.blob())
      .then((blob) => {
        const objectURL = URL.createObjectURL(blob)
        setImageURL(objectURL)
      })
      .catch((error) => {
        console.error('Erro ao converter ZPL em imagem:', error)
      })
  }, [zplCode])

  return (
    <div style={{ width: '800px', height: '800px' }}>
      {imageURL && (
        <img
          src={imageURL}
          alt="ZPL Renderizado"
          style={{ width: '100%', height: '100%' }}
        />
      )}
    </div>
  )
}

export default ZPLRenderer
